import { accountListDataSelectorConfig } from './accountListData'

export const selectorsConfig = {
  ...accountListDataSelectorConfig,
}
